import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";

const ViewCommitteeDetailsModal = ({ isOpen, onClose, committee }) => {
    const {t}=useTranslation();
    if (!isOpen || !committee) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '800px', maxWidth: '95%' }}>
                {/* Modal Header using your CSS classes */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.committeeDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh' }}>
                    {/* Committee Name Row - Styled like your Add Form */}
                    <div className="flex justify-center items-center gap-4 mb-6 mt-2">
                        <label className="staff-modal-label" style={{ marginBottom: 0 }}>
                            {t('forms.committee.committeeName')} :
                        </label>
                        <span className="text-sm font-bold text-gray-800">
                            {committee.committeeName}
                        </span>
                    </div>

                    {/* Members Table - Styled like image_f4247d.png */}
                    <div className="border border-black rounded-sm overflow-hidden mx-auto" style={{ width: '90%' }}>
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-white border-b border-black">
                                    <th className="p-2 text-center border-r border-black font-bold w-16">{t('tables.srNo')}</th>
                                    <th className="p-2 text-center font-bold">{t('forms.member.name')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {committee.members && committee.members.length > 0 ? (
                                    committee.members.map((member, index) => (
                                        <tr key={member.id || index} className="border-b border-black last:border-0">
                                            <td className="p-2 text-center border-r border-black">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left">{member.name}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="p-4 text-center text-gray-500 italic">
                                            No members assigned.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer with Close button matching your save button style */}
                <div className="staff-form-footer">
                    <button className="staff-btn-save" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewCommitteeDetailsModal;